<template>
	<div>
		<a-modal title="预约修改" :width="540" :visible="visible"  @cancel="handleCancel" >
			<template slot="footer" >
				<a-button  key="back"  @click="handleCancel">
					取消
				</a-button>
				<a-button  key="submit" type="primary" @click="onSubmit" :loading="confirmLoading">
					确认修改
				</a-button>
			</template>
			<div>
				<a-spin :spinning="loading">
					<a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
						<!-- <a-spin :spinning="showMemberLoading">
							<a-form-model-item required label="选择用户" v-if="JSON.stringify(form.member) == '{}'">
								<div class="alcenter flex">
									<a-input-search v-model="search.mobile" placeholder="请输入用户手机号"  style="width: 160px" @search="onSearch" />
									<div class="ml10 flex alcenter ft12 ftw400 cl-notice" v-if="msgStatus">
										<div>暂无该用户，请重新输入或 </div>
										<div class="cl-theme clickAct" @click="addMemberAct()">添加会员</div>
									</div>
								</div>
							</a-form-model-item>
							
							<a-form-model-item  label="选中的用户" v-if="JSON.stringify(form.member) != '{}'">
								<div class="flex alcenter ml10">
									<div class="flex alcenter">
										<div class="ft14 ftw400 cl-main">昵称：</div>
										<div class="ft14 ftw400 cl-black ml5">{{form.member.nick_name}}</div>
									</div>
									
									<div class="flex alcenter ml20">
										<div class="ft14 ftw400 cl-main">手机号：</div>
										<div class="ft14 ftw400 cl-black ml5">{{form.member.mobile}}</div>
									</div>
									
									<div class=" ml20">
										<a-button type="primary" @click="reChooseAct()">重新选择</a-button>
									</div>
								</div>
							</a-form-model-item>
						</a-spin> -->
						
						<a-form-model-item label="选择技师" required>
							<div @click="chooseTechnicianAct()" v-if="JSON.stringify(form.technician) == '{}'"  class="choose-technician-box ml10 clickAct flex center alcenter cl-theme ft14 ftw600">
								选择<i class="iconfont iconicon_arrowr ft14 ml5"/>
							</div>
							
							<div v-else class="choose-technician-box flex  space">
								<div class="flex alcenter">
									<img  :src="form.technician.face" class="choose-technician-box-face"/>
									<div class="ml10">
										<div class="ft16 ftw600 cl-main text-over4">{{form.technician.name}}</div>
										<div class="mt15 flex alcenter">
											<i class="iconfont iconcall_gray mr5 ft12 cl-notice"/>
											<div class="cl-info ft12 ftw400 text-over4">{{form.technician.mobile}}</div>
										</div>
									</div>
								</div>
								<div class="flex alcenter cente ft14 ftw600 cl-theme clickAct" @click="chooseTechnicianAct()">
									重新选择<i class="iconfont iconicon_arrowr ft14 ml5"/>
								</div>
							</div>
						</a-form-model-item>
						
						<!-- <a-form-model-item label="选择服务" required>
							<div @click="chooseProjectAct()" v-if="JSON.stringify(form.project) == '{}'"  class="choose-project-box ml10 clickAct flex center alcenter cl-theme ft14 ftw600">
								选择<i class="iconfont iconicon_arrowr ft14 ml5"/>
							</div>
							
							<div v-else class="choose-project-box flex space">
								<div style="width: 250px;" class="flex alcenter">
									<img  :src="form.project.cover_img" class="choose-project-box-cover-img"/>
									<div class="ml10">
										<div class="ft14 ftw400 cl-black text-over4">{{form.project.abbreviation}}</div>
									</div>
								</div>
								<div @click="chooseProjectAct()" class="flex alcenter cente ft14 ftw600 cl-theme clickAct" >
									重新选择<i class="iconfont iconicon_arrowr ft14 ml5"/>
								</div>
							</div>
						</a-form-model-item> -->
						
						<a-form-model-item label="预约时间" required>
							<a-date-picker  valueFormat="YYYY-MM-DD" v-model="form.day"/>
							<div class="mt10">
								<select-time-range v-model="form.appoint_time"></select-time-range>
							</div>
						</a-form-model-item>

						<a-form-model-item required label="调整价格">
							<a-input-number v-model="form.current_price"  :formatter="value => `${value}元`" placeholder="请输入" :precision="2" :min="0" style="width: 120px;"/>
						</a-form-model-item>
					</a-form-model>	
				
					<div v-if="addMemberVisible">
						<add-member v-model="form.member" :visible="addMemberVisible" @cancel="cancelAddMember" @ok="okAddMember"></add-member>
					</div>
					<div v-if="chooseTechnicianVisible">
						<choose-technician v-model="form.technician" :visible="chooseTechnicianVisible" @cancel="cancelChooseTechnician" @ok="okChooseTechnician" :mendian_id="mendian_id"></choose-technician>
					</div>
					<div v-if="chooseProjectVisible">
						<choose-course v-model="form.project" :visible="chooseProjectVisible" @cancel="cancelChooseProject" @ok="okChooseProject"></choose-course>
					</div>
				</a-spin>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import addMember from '../../../../mall/components/CustomerToOrder/modal/addMember.vue';
	import selectTimeRange from './addAppointment/selectTimeRange.vue';
	import chooseTechnician from './addAppointment/modal/chooseTechnician.vue';
	import chooseCourse from './addAppointment/modal/chooseCourse.vue';
	export default {
		props: {
			visible:{
				type:Boolean,
				default:false,
			},
			item: {
				type:Object,
				default:{}
			}
		},
		components:{
			addMember,
			selectTimeRange,
			chooseTechnician,
			chooseCourse,
		},
		data() {
			return {
				loading: false,
				confirmLoading: false,
				addMemberVisible:false,
				showMemberLoading:false,
				chooseTechnicianVisible:false,
				chooseProjectVisible:false,
				msgStatus:false,
				labelCol: { span: 4 },
				wrapperCol: { span: 20 },
				search:{
					mobile:'',
				},
				form:{
					member:{},
					technician:{},
					project:{},
					day:'',
					appoint_time:[],
					current_price:0
				},
				mendian_id:0
			}
		},
		created(){
			//console.log('edit.item:',this.item)
			this.form.technician = this.item.technician
			this.form.day = this.item.day
			this.form.appoint_time = [this.item.start_time,this.item.end_time]
			this.form.current_price = this.item.current_price
			this.mendian_id = this.item.mendian_id
		},
		methods: {
			
			//查找会员
			onSearch(){
				if(this.showMemberLoading==true) return;
				this.showMemberLoading=true;
				this.$http.api('admin/getMemberWithMobileFromFakeOrder',{
					mobile:this.search.mobile,
				}).then(res=>{
					this.msgStatus=false;
					this.form.member=res.member;
					this.showMemberLoading=false;
				}).catch(res=>{
					this.showMemberLoading=false;
					this.msgStatus=true;
				})
				
			},
			reChooseAct(){
				this.msgStatus=false;
				this.form.member=new Object;
			},
			
			//添加会员
			addMemberAct(){
				this.addMemberVisible=true;
			},
			cancelAddMember(){
				this.addMemberVisible=false;
			},
			okAddMember(){
				this.msgStatus=false;
				this.addMemberVisible=false;
			},
			
			//选择技师
			chooseTechnicianAct(){
				this.chooseTechnicianVisible=true;
			},
			cancelChooseTechnician(){
				this.chooseTechnicianVisible=false;
			},
			okChooseTechnician(){
				this.chooseTechnicianVisible=false;
			},
			
			//选择项目
			chooseProjectAct(){
				this.chooseProjectVisible=true;
			},
			cancelChooseProject(){
				this.chooseProjectVisible=false;
			},
			okChooseProject(){
				this.chooseProjectVisible=false;
			},
			
			
			changeAppointTime(value){
				this.form.appoint_time=value;
			},
			
			/**
			 * 取消弹窗
			 */
			handleCancel() {
				this.$emit("cancel");
			},
	
			/**
			 * 提交数据
			 */
			onSubmit() {
				/*if(JSON.stringify(this.form.member) == '{}'){
					this.$message.error('请选择用户');
					return;
				}
				
				if(!this.form.member.member_id){
					this.$message.error('请选择用户');
					return;
				}
				
				
				if(JSON.stringify(this.form.project) == '{}'){
					this.$message.error('请选择项目');
					return;
				}
				
				if(!this.form.project.project_id){
					this.$message.error('请选择项目');
					return;
				}*/
				
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('admin/saveAppointmentItem',{
					//member_id:this.form.member.member_id,
					//project_id:this.form.project.project_id,
					appointment_item_id:this.item.appointment_item_id,
					technician_id:JSON.stringify(this.form.technician) == '{}' ? 0 :this.form.technician.technician_id,
					day:this.form.day,
					appoint_time:this.form.appoint_time,
					current_price:this.form.current_price
				}).then(res=>{
					this.$message.success('操作成功');
					this.$emit("ok");
					this.loading=false;
				}).catch(res=>{
					console.log(res);
					this.loading=false;
				})
			},
		}
	}
</script>

<style>
	
	.choose-technician-box{
		width: 280px;
		height: 80px;
		background: #FFFFFF;
		border-radius: 4px;
		border: 1px solid #EBEDF5;
		padding: 10px;
		line-height: 1;
	}
	
	.choose-technician-box-face{
		width: 60px;
		height: 60px;
		border-radius: 2px;
	}
	
	.choose-project-box{
		width: 400px;
		height: 80px;
		background: #FFFFFF;
		border-radius: 4px;
		border: 1px solid #EBEDF5;
		padding: 10px;
		line-height: 1;
	}
	
	.choose-project-box-cover-img{
		width: 80px;
		height: 60px;
	}
</style>
